import type { Decimal } from 'decimal.js';

interface PaymentTypes {
  cash?: Decimal;
  creditCard?: Decimal;
  creditNote?: Decimal;
  points?: Decimal;
  qantasGroupCreditVoucher?: Decimal;
  voucher?: Decimal;
}

export const getPaymentType = (
  { cash, points, creditCard, creditNote, voucher, qantasGroupCreditVoucher }: PaymentTypes,
  isDepositPay = false,
): string => {
  const paymentTypes: string[] = isDepositPay ? ['deposit pay'] : [];

  if (cash?.greaterThan(0)) paymentTypes.push('cash');
  if (points?.greaterThan(0)) paymentTypes.push('points');
  if (creditCard?.greaterThan(0)) paymentTypes.push('credit card');
  if (creditNote?.greaterThan(0)) paymentTypes.push('credit note');
  if (voucher?.greaterThan(0)) paymentTypes.push('voucher');
  if (qantasGroupCreditVoucher?.greaterThan(0)) paymentTypes.push('Qantas Group credit voucher');
  if (paymentTypes.length > 1) {
    const last = paymentTypes.pop();
    return `${paymentTypes.join(', ')} and ${last}`;
  } else if (paymentTypes[0]) {
    return paymentTypes[0];
  }

  return 'no payments';
};
